import { memo } from 'react';

import { DatePickerActionsButton, DatePickerActionsContainer } from './styled';
import { DatePickerActionsProps } from './types';

const DatePickerActionsComponent = (props: DatePickerActionsProps) => {
  const { onClear, onSave } = props;

  return (
    <DatePickerActionsContainer>
      <DatePickerActionsButton
        variant="contained"
        size="small"
        onClick={onSave}
      >
        OK
      </DatePickerActionsButton>
      <DatePickerActionsButton
        variant="outlined"
        size="small"
        onClick={onClear}
      >
        Clear
      </DatePickerActionsButton>
    </DatePickerActionsContainer>
  );
};

const DatePickerActions = memo(DatePickerActionsComponent);

DatePickerActions.displayName = 'DatePickerActions';

export { DatePickerActions };
